"use strict";

import "./Timezone-Search.less";

import React from 'react';

import moment from 'moment-timezone';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const extras = [];

const timezoneNames = moment.tz.names();
const defaultTimeZone = moment.tz.guess();

let defaultTimeZoneIndex = -1, extraArrayIndex = -1;

let options = timezoneNames.map((name, index) => {
  if(name == defaultTimeZone) defaultTimeZoneIndex = index;
  // let abbr = moment.tz(name).zoneAbbr();
  // let offset = moment.tz(name).format('Z');
  // let label = (name)
  // return {label: name, value: {name: name, abbr: abbr, offset: offset, label: label}};
  return {label: name, value: name};

  // var jun = moment("2014-06-01T12:00:00Z");
  // var dec = moment("2014-12-01T12:00:00Z");
  // let a = jun.tz(name).format('z');     // 8am EDT
  // let b = dec.tz(name).format('z');     // 7am EST
  // if(a != b) {
  //   // let abbr = moment.tz(name).zoneAbbr();
  //   if (defaultTimeZoneIndex === index) {
  //     const localOffset = moment().tz(name).format('z');
  //     if(localOffset === a) extraArrayIndex = extras.length;
  //   }
  //   let offset = jun.tz(name).format('Z');
  //   let label = (name + ' | ' + a + ' | ' + 'GMT' + offset);
  //   extras.push({ label: label, value: { name: name, abbr: a, offset: offset, label: label } });
  //   offset = dec.tz(name).format('Z');
  //   label = (name + ' | ' + b + ' | ' + 'GMT' + offset)
  //   return { label: label, value: { name: name, abbr: b, offset: offset, label: label } };
  // }
  // else {
  //   let abbr = moment.tz(name).zoneAbbr();
  //   let offset = moment.tz(name).format('Z');
  //   let label = (name + ' | ' + abbr + ' | ' + 'GMT' + offset)
  //   return {label: label, value: {name: name, abbr: abbr, offset: offset, label: label}};
  // }
})

// if (extras.length) {
//   if (extraArrayIndex > -1)  {
//     defaultTimeZoneIndex = options.length + extraArrayIndex;
//   }
//   options.push(...extras);
// }

class TimezoneSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: null
    }
    this._handleSelection = this._handleSelection.bind(this);
  };

  static propTypes = {
    onSelection: React.PropTypes.func,
  };

  componentWillMount() {
  };

  componentDidMount() {
    // console.log("enter in did mount");
    const { dtz } = this.props;
    console.log({dtz});
    let index = -1;
    if (dtz) {
      if (dtz.name && dtz.abbr) {
        index = options.findIndex(o => o.value.abbr == dtz.abbr && o.value.name == dtz.name)
      } else {
        index = moment.tz.names().findIndex(name => name == dtz);
      }
    }

    if(index > -1) {
      // console.log("Redfy to call handle selection", options);
      this._handleSelection(options[index].value, true);
      // this.setState({selectedOption : options[index].value})
    }

    if (defaultTimeZoneIndex > -1 && !(!!dtz)) {
      // console.log("Redfy to call handle selection 222222");
      // console.log("defaultTimeZoneIndex -> option", options[defaultTimeZoneIndex]);
      this._handleSelection(options[defaultTimeZoneIndex].value, true);
    }
  }

  componentWillUnmount() {
  };

  render() {
    // console.log("this.state.selectedOption", this.state.selectedOption);
    return (
      <Select
        name="timezoneSearch"
        placeholder = 'Select Timezone'
        value={this.state.selectedOption}
        onChange={(ev) => {
          if (ev) 
            ev.value && this._handleSelection(ev.value);
          else 
            this._handleSelection(null);
        }}
        options={options}
      />
    )
  };

  _handleSelection(selectedOption, suppressEvent) {
    // console.log("selectedOption", selectedOption, suppressEvent);
    if(suppressEvent) {
      this.setState({ selectedOption });
    }
    else {
      this.setState({ selectedOption }, () => {
        this.props._handleSelection(selectedOption);
      });
    }
  };


}

export default TimezoneSearch;
